module.exports = __webpack_public_path__ + "img/calendar.25a49a0f.svg";